import * as types from '../actions/actionTypes';

const initialState = {
  receiptUrl: "",
  receiptSignature: "", // pngBase64
  receiptReferral: null, // this is for dashboard messaging, to create purchase order receipt // dashboard job object
};

export default function (state = initialState, action) {

  switch (action.type) {

    case types.SET_RECEIPT_URL:
    case types.SET_RECEIPT_SIGNATURE:
    case types.SET_RECEIPT_REFERRAL:
      return Object.assign({}, state, {
        ...action.payload
      });
  }

  return state;

}
